module.exports = __webpack_public_path__ + "media/images/athletes/2106-cdd399efcc200c8445ba078a5181c9c2.png";